import Navbar from "../../components/navbar/Navbar";
import Footer from "../../components/footer/Footer";

import "./contact.css";

function Contact() {
  return (
    <div className="contact">
      <Navbar />
      <div className="contact--content">
        <div className="contact--hero">
          <h1>Get in touch</h1>
          <p>
            Want to get in touch? We'd love to hear from you. Here's how you can
            reach us...
          </p>
        </div>
        <div className="contact-box">
          <div className="contact--single--box facebook">
            <i className="fab fa-facebook fa-3x"></i>
            <h1>Our Main Office</h1>
            <p>
              Nakuru, Kenyatta Avenue Highwa <br></br> Tower one
            </p>
          </div>
          <div className="contact--single--box">
            <i class="far fa-comments fa-3x"></i>
            <h1>Our chat section</h1>
            <p>
            Send us a message by clicking the button below.
                      </p>
                      <button className='chat--btn'>Chat</button>
          </div>
          <div className="contact--single--box gmail fa-3x">
          <i class="fab fa-google-plus-square"></i>
            <h1>Mail us</h1>
            <p>
              Send us an Email via: <br></br>
              exquisitartservices@gmai.com
            </p>
            
          </div>
          <div className="contact--single--box mobile">
            <i class="fas fa-mobile-alt fa-3x"></i>
            <h1>Call us </h1>
            <p><b>Call us on:</b> <br></br> +254 742 068 914 <br></br> +254 737 725 951</p>
          </div>
        </div>
        <div className='contact--main'>
            <form className='contact--form'>
                <input type='email' placeholder='joshua@gmial.com'/>
                <textarea placeholder='Write message'></textarea>
                <button type='submit' className='contact-btn'> Send</button>
            </form>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Contact;
